// Adaptér nativního Shoptet výpisu hledání → model pro `searchRender.js`
// (issue #74). Protějšek budoucího `searchApi.js`: oba vracejí TENTÝŽ tvar,
// takže renderer nepozná, odkud data přišla.
//
// Tohle je jediné místo, které ví, jak vypadá nativní DOM stránky
// `body.type-search`. Když Shoptet markup změní, opravuje se jen tenhle soubor.
//
// OMEZENÍ DAT (ověřeno na dev instanci 2026-07-28, platí pro fallback cestu):
//   • Shoptet nikde nevystavuje CELKOVÝ počet nalezených produktů — `.loadMore`
//     hlásí jen velikost další dávky („Načíst 24 dalších" i po dosypání) a
//     `.listItemsTotal` / `.category-header-pagination` na hledání nejsou.
//     Proto `products.total === null` → renderer kreslí „N+". Vlastní index
//     `total` má, takže tam „+" samo zmizí.
//   • Skupiny nemají u položek počty ani cestu kategorie → `count: null`.
//   • Stav „prázdný dotaz" na Shoptetu neexistuje: `/vyhledavani/` i
//     `/vyhledavani/?string=` přesměruje na homepage.

import { currentQuery } from './searchSuggest.js';

// Nativní id skupiny → typ vykreslení. Neznámé id (např. stránky, pokud je
// shop někdy vrátí) padá na řádkovou variantu.
const GROUP_KINDS = {
  'search-group-categories': 'cats',
  'search-group-manufacturers': 'brands',
  'search-group-articles': 'posts',
};

function text(node) {
  return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
}

export function isSearchPage() {
  return document.body.classList.contains('type-search');
}

export function productBlock() {
  return document.querySelector('#products-found #products');
}

function productCount() {
  const block = productBlock();
  return block ? block.querySelectorAll('.p[data-micro="product"]').length : 0;
}

function hasMore() {
  return !!document.querySelector('.loadMore__button');
}

/**
 * Stav produktové mřížky — čte se znovu po každém `loadMore`.
 * `present` = sekce produktů na stránce vůbec je (mřížka smí být i prázdná,
 * pilulka „Produkty" se pak pořád kreslí — tak to dělal #31).
 */
export function readProducts() {
  return { present: !!productBlock(), shown: productCount(), total: null, hasMore: hasMore() };
}

function readSections() {
  return Array.prototype.map.call(document.querySelectorAll('.search-results-group'), function (node) {
    const items = node.querySelectorAll('.search-results-group-list li');
    // „Zobrazit vše (17)" nese skutečný počet včetně skrytých `li.no-display`
    const all = text(node.querySelector('.display-results-group')).match(/(\d+)/);
    return {
      node: node,
      id: node.id,
      kind: GROUP_KINDS[node.id] || 'pages',
      label: text(node.querySelector('h4')),
      count: all ? parseInt(all[1], 10) : items.length,
    };
  });
}

/** Nativní DOM → model (tvar viz hlavička `searchRender.js`). */
export function readModel() {
  return {
    query: currentQuery(),
    products: readProducts(),
    sections: readSections(),
  };
}
